module.exports = __webpack_public_path__ + "static/media/maternity10.0a570f9b.jpg";